import { BInputGroupAppend } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBInputGroupAppend = createEgBootstrapProxy(
  "EgBInputGroupAppend",
  BInputGroupAppend
);
